export default __webpack_public_path__ + "static/andrey-072d0100ef7d19a05527377e2ccacfe4.jpg";